// Native drawers already wrap the account footer in SafeAreaView edges=['bottom'].
// Adding insets.bottom on the button again leaves a large empty band under the row.
export function resolveAccountButtonPadding({
  platform,
  bottomInset = 0,
  isXS = false,
  compact = false,
} = {}) {
  const nativeMobile = platform === 'ios' || platform === 'android';
  if (compact) {
    return {
      paddingHorizontal: 8,
      paddingTop: 8,
      paddingBottom: 8 + bottomInset,
    };
  }
  if (nativeMobile) {
    return {
      paddingLeft: 12,
      paddingRight: 12,
      paddingTop: 6,
      paddingBottom: 6,
    };
  }
  return {
    paddingLeft: isXS ? 20 : 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10 + bottomInset,
  };
}
